import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageImageUploader from '../view/FJTextToImageImageUploader';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import { removeUploadImages } from '../../../../redux/slices/FJSliceTextToImage';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import {
    CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
    UPLOAD_FILE_TYPE_NO_GIF,
    UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE,
} from '../../../../config/dataConfig/FJGenerateData.js';

const FJTextToImageImageUploaderContainer = memo(function FJTextToImageImageUploaderContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const uploadImageInfo = useSelector(state => state.textToImage.uploadImageInfo);
    const uploadImages = useSelector(state => state.textToImage.uploadImages);
    const uploadStatus = useSelector(state => state.textToImage.uploadStatus);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const curModel = useSelector(state => state.textToImage.curModel);
    const supportImageReferenceNum = useMemo(() => {
        return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.supportImageReferenceNum || 1;
    }, [curModel]);
    const setIsDraggingFile = useCallback(
        isDraggingFile => {
            dispatch(setSliceIsDraggingFileAction(isDraggingFile));
        },
        [dispatch],
    );

    const handleImageUpload = useCallback(
        file => {
            dispatch(FJActionTextToImage.uploadImageAction(file));
        },
        [dispatch],
    );

    const openMediaLibrary = useCallback(() => {
        dispatch(
            FJActionEditPage.openMediaLibraryAction({
                uploadConfig: {
                    // 上传文件规则
                    isMultiple: supportImageReferenceNum > 1,
                    maxMediaNum: supportImageReferenceNum,
                    selectedMediaIds: [],
                    acceptTypeWithTranscode: UPLOAD_FILE_TYPE_NO_GIF + CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    acceptTypeNoTranscode: UPLOAD_IMAGE_FILE_TYPE_NO_NEED_TRANSCODE, // 上传后的校验使用
                    suffixTranscode: CLOUD_TRANSCODE_SUPPORTED_FILE_TYPE_IMAGES,
                    // 媒体库的过滤规则
                    mediaFilterFunc: item => {
                        const mediaTypes = ['IMAGE'];
                        return mediaTypes.includes(item.type);
                    },
                    // 上传文件之后返回的数据
                    callbackOptions: {},
                },
            }),
        );
    }, [dispatch, supportImageReferenceNum]);

    const handleDeleteImage = useCallback(() => {
        dispatch(FJActionTextToImage.clearUploadImageAction());
    }, [dispatch]);
    const handleUploadMultiple = useCallback(
        files => {
            dispatch(FJActionTextToImage.uploadMultipleImagesAction(files));
        },
        [dispatch],
    );

    const handleRemoveImage = useCallback(
        index => {
            dispatch(removeUploadImages(index));
        },
        [dispatch],
    );

    return (
        <FJTextToImageImageUploader
            onUpload={handleImageUpload}
            onOpenMediaLibrary={openMediaLibrary}
            uploadImageInfo={uploadImageInfo}
            uploadStatus={uploadStatus}
            setIsDraggingFile={setIsDraggingFile}
            isDraggingFile={isDraggingFile}
            onDelete={handleDeleteImage}
            uploadImages={uploadImages}
            handleUploadMultiple={handleUploadMultiple}
            handleRemoveImage={handleRemoveImage}
            supportImageReferenceNum={supportImageReferenceNum}
        />
    );
});

export default FJTextToImageImageUploaderContainer;
